import TweenMax from "gsap/gsap-core";

if ($('.cursor-follower').length > 0) {
    var cursor = $(".cursor"),
        follower = $(".cursor-follower");

    var posX = 0,
        posY = 0;

    var mouseX = 0,
        mouseY = 0;

    if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {

        TweenMax.to({}, 0.016, {
            repeat: -1,
            onRepeat: function () {
                posX += (mouseX - posX) / 9;
                posY += (mouseY - posY) / 9;

                TweenMax.set(follower, {
                    css: {
                        left: posX - 12,
                        top: posY - 12
                    }
                });

                /*TweenMax.set(cursor, {
                    css: {
                        left: mouseX,
                        top: mouseY
                    }
                });*/
            }
        });

        $(document).on("mousemove", function (e) {
            mouseX = e.clientX;
            mouseY = e.clientY;

            setTimeout(function () {
              //  $('#musicplayer').trigger('play');
            }, 500)
        });

        $('a, button').mouseenter(function () {
            $(".cursor-follower").addClass('js-isActive');
        }).mouseleave(function () {
            $(".cursor-follower").removeClass('js-isActive');
        });

    } else {
        cursor.remove();
        follower.remove();
    }
}
